<div class="loading-content-placeholder">
    <ng-container *ngIf="config.type === ConfigType.SIMPLE">
        <div *ngFor="let row of [].constructor(config.rowsAmount)" class="loading-content-placeholder__row">
            <div *ngFor="let cell of [].constructor(config.columnsAmount)"
                 class="loading-content-placeholder__row__cell"
                 [ngClass]="{
                    'loading-content-placeholder__row__cell--small': config.cellSize === CellSize.SMALL,
                    'loading-content-placeholder__row__cell--large': config.cellSize === CellSize.LARGE
                 }"
            ></div>
        </div>
    </ng-container>

    <ng-container *ngIf="config.type === ConfigType.ADVANCED">
        <div *ngFor="let row of config.rows" class="loading-content-placeholder__row">
            <div *ngFor="let cell of row.cells"
                 class="loading-content-placeholder__row__cell"
                 [ngClass]="{
                    'loading-content-placeholder__row__cell--small': cell.size === CellSize.SMALL,
                    'loading-content-placeholder__row__cell--large': cell.size === CellSize.LARGE
                 }"
            ></div>
        </div>
    </ng-container>
</div>
